// import Vue from 'vue';
// import Utility from '@/vue/utility/utility';
import BaseModule from '../_base_module';

// initial state
// shape: [{ id, quantity }]
const state = {
  ...BaseModule.state,

  data: [],
};

// getters
const getters = {
  ...BaseModule.getters,
  all(state, getters, rootState, rootGetters) {
    return state.data;
    // return Object.keys(state.data).filter(exercise_id => {
    //   return state.data[exercise_id] !== null;
    // });
  }
};

// actions
const actions = {
  ...BaseModule.actions,
  fetch_all ({state, commit, dispatch, getters, rootState}, payload) {
      dispatch('api/getEndpoint', {
        endpoint: '/exercises'
      }, {root: true}).then(response => {
        commit('set_state', {property: 'data', value: response.data.data});
      });
  }
};

// mutations
const mutations = {
  ...BaseModule.mutations,
  // dummy_mutation (state, id) {
  //     state.id = id;
  // },
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
